import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="bg-primary text-white py-12">
      <div className="container mx-auto px-6">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12">
          <div className="space-y-6">
            <div className="flex items-center space-x-4">
              <img
                src="/logos/logo.png"
                alt="Chicken Farm Experts Logo"
                className="h-20 w-auto"
                style={{ objectFit: 'contain' }}
              />
              <h3 className="text-lg font-bold text-primary">Chick Farm</h3>
            </div>
            <p className="text-sm text-gray-300 leading-relaxed max-w-md">
              Committed to advancing poultry health and sustainable farming with over 10 years of expertise in veterinary care and farm management.
            </p>
          </div>
          <div className="space-y-6">
            <h3 className="text-lg font-bold text-primary mb-4">Navigation</h3>
            <ul className="space-y-2">
              <li><Link to="/" className="text-gray-300 hover:text-secondary transition duration-200">Home</Link></li>
              <li><Link to="/services" className="text-gray-300 hover:text-secondary transition duration-200">Services</Link></li>
              <li><Link to="/contact" className="text-gray-300 hover:text-secondary transition duration-200">Contact</Link></li>
              <li><Link to="/specialists" className="text-gray-300 hover:text-secondary transition duration-200">Specialists</Link></li>
            </ul>
          </div>
          <div className="space-y-6">
            <h3 className="text-lg font-bold text-primary mb-4">Stay Updated</h3>
            <div className="flex flex-col md:flex-row gap-4 bg-white/10 p-3 sm:p-4 rounded-lg shadow-md max-w-full">
              <input
                type="email"
                placeholder="Enter your email"
                className="w-full px-3 sm:px-4 py-2 rounded-md text-gray-800 bg-white md:max-w-xs"
              />
              <button className="bg-secondary text-white px-4 sm:px-6 py-2 rounded-md hover:bg-opacity-90 transition duration-300 font-medium">
                Subscribe
              </button>
            </div>
            <div className="flex space-x-6">
              {/* Replace with real URLs when available */}
              <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" className="text-gray-300 hover:text-secondary transition duration-200">Facebook</a>
              <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" className="text-gray-300 hover:text-secondary transition duration-200">Twitter</a>
              <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" className="text-gray-300 hover:text-secondary transition duration-200">LinkedIn</a>
            </div>
          </div>
          <div className="space-y-6">
            <h3 className="text-lg font-bold text-primary mb-4">Contact Us</h3>
            <div className="space-y-3">
              <div className="flex items-center space-x-3">
                <span className="text-primary">📞</span>
                <p className="text-sm text-gray-300">+44 161 566 9077</p>
              </div>
              <div className="flex items-center space-x-3">
                <span className="text-primary">✉️</span>
                <p className="text-sm text-gray-300">info@chickfarm.site </p>
              </div>
              <div className="flex items-center space-x-3">
                <span className="text-primary">📍</span>
                <p className="text-sm text-gray-300">51 Queen Ediths Way, Cambridge, United Kingdom, CB1 8PJ</p>
              </div>
            </div>
          </div>
        </div>
        <div className="mt-12 text-center text-xs text-gray-400 space-y-1">
          <p>
            © 2025 Chicken Farm Experts. All rights reserved. |{" "}
            <Link to="/privacy-policy" className="text-secondary hover:underline">
              Privacy Policy
            </Link> | {" "}
              <Link to="/Terms-and-conditions" className="text-secondary hover:underline">
             Terms & conditions
            </Link>
          </p>
          <p>
            Developed by{" "}
            <a
              href="https://igensolution.com"
              target="_blank"
              rel="noopener noreferrer"
              className="text-secondary hover:underline"
            >
              iGen Solution
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
